module.exports = __webpack_public_path__ + "static/media/face_landmarks_video.cdeeb8a2.mp4";